import Layout from '@/components/Layout';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="container mx-auto px-6 py-12 md:py-20 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-tech-darkGray text-center">מדיניות פרטיות</h1>
        
        <div className="bg-white rounded-xl p-8 shadow-sm space-y-6">
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">כללי</h2>
            <p className="text-gray-600">
              אנו  שלומית ז'בנר מכבדים את פרטיותך ומחויבים להגן על המידע האישי שאתה משתף איתנו. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע האישי שלך בעת השימוש באתר שלנו ובשירותים שאנו מציעים.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">איסוף מידע</h2>
            <p className="text-gray-600">
              אנו אוספים מידע אישי שאתה מספק לנו באופן ישיר, כגון שם, כתובת דוא"ל, מספר טלפון ופרטי קשר אחרים כאשר אתה:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
              <li>ממלא טופס יצירת קשר באתר שלנו</li>
              <li>נרשם לשירותים שלנו</li>
              <li>מבקש לקבל מידע או הצעת מחיר</li>
              <li>מתקשר איתנו באמצעות הוואטסאפ או אמצעי תקשורת אחרים</li>
            </ul>
            <p className="text-gray-600">
              בנוסף, אנו עשויים לאסוף מידע באופן אוטומטי כאשר אתה מבקר באתר שלנו, כולל כתובת IP, סוג דפדפן, העדפות שפה, מערכת הפעלה, דפי האינטרנט בהם ביקרת ומידע אחר אודות האופן שבו אתה משתמש באתר.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">שימוש במידע</h2>
            <p className="text-gray-600">
              אנו משתמשים במידע שנאסף למטרות הבאות:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
              <li>לספק ולשפר את השירותים שלנו</li>
              <li>לענות לפניות ובקשות שלך</li>
              <li>לשלוח לך מידע שביקשת או עשוי להיות רלוונטי לך</li>
              <li>לתקשר איתך בנוגע לשירותים שלנו</li>
              <li>לנתח ולשפר את האתר והשירותים שלנו</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">שיתוף מידע</h2>
            <p className="text-gray-600">
              אנו לא מוכרים, משכירים או מחליפים את המידע האישי שלך עם צדדים שלישיים, למעט במקרים הבאים:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
              <li>כאשר יש לנו את הסכמתך לעשות זאת</li>
              <li>עם ספקי שירות שעובדים בשמנו לספק את השירותים שלנו</li>
              <li>כאשר נדרש על פי חוק או כדי להגן על הזכויות שלנו</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">אבטחת מידע</h2>
            <p className="text-gray-600">
              אנו נוקטים באמצעים סבירים כדי להגן על המידע האישי שלך מפני אובדן, גישה לא מורשית, שימוש לרעה, שינוי או חשיפה. עם זאת, שום שיטת העברה באינטרנט או אחסון אלקטרוני אינה בטוחה ב-100%.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">זכויותיך</h2>
            <p className="text-gray-600">
              יש לך זכויות מסוימות בנוגע למידע האישי שלך, כולל:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
              <li>לבקש גישה למידע האישי שלך</li>
              <li>לבקש לתקן או למחוק את המידע האישי שלך</li>
              <li>להתנגד לעיבוד המידע האישי שלך</li>
              <li>לבקש הגבלה על עיבוד המידע האישי שלך</li>
              <li>לבקש לייצא את המידע האישי שלך</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">עדכונים למדיניות הפרטיות</h2>
            <p className="text-gray-600">
              אנו עשויים לעדכן את מדיניות הפרטיות הזו מעת לעת. נפרסם כל שינוי באתר שלנו ונעדכן את תאריך העדכון האחרון בראש מדיניות הפרטיות.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-tech-darkGray">יצירת קשר</h2>
            <p className="text-gray-600">
              אם יש לך שאלות או חששות בנוגע למדיניות פרטיות זו, אנא צור איתנו קשר באמצעות הפרטים הבאים:
            </p>
            <div className="bg-tech-gray p-4 rounded-lg">
              <p className="text-gray-600">דוא"ל:support@zabnerit.com</p>
              <p className="text-gray-600">טלפון: 054-728562</p>
            </div>
          </section>

          <p className="text-gray-500 text-sm mt-8 text-center">
            עדכון אחרון: מרץ 2025
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;